// react
import React from 'react';

// third-party
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, Redirect, useHistory } from 'react-router-dom';

// application
import AsyncAction from './AsyncAction';
import Currency from './Currency';
import Rating from './Rating';
import { cartAddItem } from '../../store/cart';
import { Compare16Svg, Quickview16Svg, Wishlist16Svg } from '../../svg';
import { compareAddItem } from '../../store/compare';
import { quickviewOpen } from '../../store/quickview';
import { url } from '../../services/utils';
import { wishlistAddItem } from '../../store/wishlist';
import { useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import { updateAction } from '../../store/auth/authActions';

function ProductCardPromo(props) {
    const {
        product,
        layout,
        quickviewOpen,
        waktu,
        cartAddItem,
        wishlistAddItem,
        compareAddItem,
    } = props;
    const containerClasses = classNames('product-card', {
        'product-card--layout--grid product-card--size--sm': layout === 'grid-sm',
        'product-card--layout--grid product-card--size--nl': layout === 'grid-nl',
        'product-card--layout--grid product-card--size--lg': layout === 'grid-lg',
        'product-card--layout--list': layout === 'list',
        'product-card--layout--horizontal': layout === 'horizontal',
    });

    const formatPriceNumber = (val) => {
        const num = Number(val) || 0;
        return new Intl.NumberFormat('id-ID', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(num);
    };

    let badges = [];
    let image;
    let price;
    let features;

    badges = badges.length ? <div className="product-card__badges-list" align="right">{badges}</div> : null;

    image = (
        <div className="product-card__image product-image">
            <Link to={url.product(product)} className="product-image__body">
                <img
                    className="product-image__img"
                    src={product.image_url || product.photo}
                    alt={product.item_name || 'Produk'}
                    loading="lazy"
                />
            </Link>
        </div>
    );

    if (product && product.compareAtPrice && Number(product.compareAtPrice) > Number(product.price_6 || product.price)) {
        price = (
            <div className="product-card__prices">
                <span className="product-card__new-price">Rp{formatPriceNumber(product.price_6 || product.price)}</span>
                <span className="product-card__old-price">Rp{formatPriceNumber(product.compareAtPrice)}</span>
            </div>
        );
    } else {
        price = (
            <div className="product-card__prices">
                <span className="product-card__new-price">Rp{formatPriceNumber(product.price_6 || product.price)}</span>
            </div>
        );
    }

    // if (product && product.attributes && product.attributes.length) {
        // features = (
        //     <ul className="product-card__features-list">
        //         {product.attributes.filter((x) => x.featured).map((attribute, index) => (
        //             <li key={index}>{`${attribute.name}: ${attribute.values.map((x) => x.name).join(', ')}`}</li>
        //         ))}
        //     </ul>
        // );
    // }

    const history = useHistory();
    const [qty, setQty] = useState(1);
    const [loadingCart, setLA] = useState(false);
    const [update, setUpdate] = useState(false);

    const { token } = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    const getActiveToken = () => {
        if (token) return token;
        try {
            const stored = JSON.parse(localStorage.getItem('state') || '{}');
            const found = stored?.auth?.token || localStorage.getItem('token');
            if (found) return found;
        } catch (e) {
            return localStorage.getItem('token');
        }
        return localStorage.getItem('token');
    };

    const add2Cart = async (body) => {
        try {
            const activeToken = getActiveToken();
            if (!activeToken) {
                toast.warning('Silakan login terlebih dahulu untuk menambah ke keranjang');
                history.push('/account/login');
                return;
            }

            setLA(true);
            const result = await axios({
                method: "POST",
                url: `${process.env.REACT_APP_HOST_API}/cart/save`,
                headers: {
                    Authorization: `Bearer ${activeToken}`,
                },
                data: body,
            });
            setLA(false);
            setUpdate(true);
            setTimeout(() => {
                setUpdate(false);
            }, 500);
            toast.success('Product successfully added');

            try {
                const res = await axios({
                    method: 'GET',
                    url: `${process.env.REACT_APP_HOST_API}/cart/list`,
                    headers: {
                        Authorization: `Bearer ${activeToken}`,
                    },
                });
                const items = Array.isArray(res.data?.response) ? res.data.response : [];
                const sum = items.reduce((acc, curr) => acc + (parseInt(curr.qty, 10) || 0), 0);
                localStorage.setItem('cart_total', sum);
                window.dispatchEvent(new CustomEvent('cart:count_updated', { detail: sum }));
            } catch (e) {
                // fallback
            }

            dispatch(updateAction(true));
            setTimeout(() => {
                dispatch(updateAction(false));
            }, 1000);
        } catch (error) {
            setLA(false);
            console.log(error);
            toast.error('There was an error saving your cart');
        }
    };

    const handleCardClick = (e) => {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
            return;
        }
        if (e.target.closest('button, .product-card__quickview, .product-card__buttons, input, textarea, select')) {
            return;
        }
        if (e.target.closest('a')) {
            return;
        }
        const targetUrl = url.product(product);
        if (targetUrl) {
            history.push(targetUrl);
        }
    };

    return (
        <div className={containerClasses} onClick={handleCardClick}>
            <AsyncAction
                action={() => quickviewOpen(product.id)}
                render={({ run, loading }) => (
                    <button
                        type="button"
                        onClick={run}
                        className={classNames('product-card__quickview', {
                            'product-card__quickview--preload': loading,
                        })}
                    >
                        <Quickview16Svg />
                    </button>
                )}
            />
            {badges}
            {image}
            <div className="product-card__info">
                <div className="product-card__name">
                    <Link to={url.product(product)} title={product.item_name}>
                        <span className="product-card__name-text">
                            {product.item_name}
                        </span>
                    </Link>
                </div>
            </div>
            <div className="product-card__actions">
                <div className="product-card__availability">
                    Availability:
                    <span className="text-success">In Stock</span>
                </div>
                {price}
                <div className="product-card__location">
                    <span className="product-card__location-badge">
                        <svg
                            className="product-card__location-icon"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                        >
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                            <circle cx="12" cy="10" r="3" />
                        </svg>
                        <span className="product-card__location-name">
                            {product.warehouse_name || 'Hokky Bangunan'}
                        </span>
                    </span>
                </div>
                <div className="product-card__buttons">
                    <AsyncAction
                        action={() => add2Cart({
                            item_id: product.item_id,
                            qty: qty,
                            warehouse_id : product.warehouse_id,
                            type : product.type,
                            price_6 : product.price_6,
                          })}
                        render={({ run, loading }) => (
                            <React.Fragment>
                                {/* <button
                                    type="button"
                                    onClick={run}
                                    className={classNames('btn btn-primary product-card__addtocart', {
                                        'btn-loading': loading,
                                    })}
                                >
                                    Beli
                                </button> */}
                                {/* <button
                                    type="button"
                                    onClick={run}
                                    className={classNames('btn btn-secondary product-card__addtocart product-card__addtocart--list', {
                                        'btn-loading': loading,
                                    })}
                                >
                                    Beli
                                </button> */}
                            </React.Fragment>
                        )}
                    />
                    {/* <AsyncAction
                        action={() => wishlistAddItem(product)}
                        render={({ run, loading }) => (
                            <button
                                type="button"
                                onClick={run}
                                className={classNames('btn btn-light btn-svg-icon btn-svg-icon--fake-svg product-card__wishlist', {
                                    'btn-loading': loading,
                                })}
                            >
                                <Wishlist16Svg />
                            </button>
                        )}
                    />
                    <AsyncAction
                        action={() => compareAddItem(product)}
                        render={({ run, loading }) => (
                            <button
                                type="button"
                                onClick={run}
                                className={classNames('btn btn-light btn-svg-icon btn-svg-icon--fake-svg product-card__compare', {
                                    'btn-loading': loading,
                                })}
                            >
                                <Compare16Svg />
                            </button>
                        )}
                    /> */}
                </div>
            </div>
        </div>
    );
}

ProductCardPromo.propTypes = {
    /**
     * product object
     */
    product: PropTypes.object.isRequired,
    /**
     * product card layout
     * one of ['grid-sm', 'grid-nl', 'grid-lg', 'list', 'horizontal']
     */
    layout: PropTypes.oneOf(['grid-sm', 'grid-nl', 'grid-lg', 'list', 'horizontal']),
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    cartAddItem,
    wishlistAddItem,
    compareAddItem,
    quickviewOpen,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProductCardPromo);
